import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserBloc } from '@kp/user/user.bloc';
import { DataStoreService, TitleService } from '@kservice';
import { DeletionRequestStatus } from '@ktypes/enums';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-screen-deletion-confirmation',
  templateUrl: './screen-deletion-confirmation.component.html',
  styleUrls: ['./screen-deletion-confirmation.component.scss'],
})
export class ScreenDeletionConfirmationComponent implements OnInit, OnDestroy {
  processing = false;
  showError = false;

  private _title = 'Account Deletion Confirmation';

  private _destroy$ = new Subject<void>();

  constructor(
    public dataStoreService: DataStoreService,
    private _router: Router,
    private _userBloc: UserBloc,
    private titleService: TitleService
  ) {}

  ngOnInit() {
    this.titleService.set(this._title);

    this._userBloc.deleteUserRequestStatus$.pipe(takeUntil(this._destroy$)).subscribe((status) => {
      this.processing = false;
      if (status === DeletionRequestStatus.deletionRequested) {
        void this._router.navigate(['/deletion']);
      } else if (status === DeletionRequestStatus.hasErrored) {
        this.showError = true;
      }
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  deleteAccount() {
    console.log(`Sending account deletion email to ${this.dataStoreService.user?.email}`);
    this.processing = true;
    this._userBloc.requestDeleteUser();
  }
}
